import apisauce, { CancelToken } from 'apisauce';
import fernet  from 'fernet';

const secret = new fernet.Secret(process.env.REACT_APP_FERNET_SECRET_KEY)
const token = new fernet.Token({secret})

export const encryptedData = (data) => {
  let encrypted = token.encode(JSON.stringify(data))
  return ({encrypted})
}

export class API {
  constructor() {
    this.baseURL = process.env.REACT_APP_BASE_API_ROUTE;

    if (!API.instance) {
      this.create();
      this.createInterceptor();

      API.instance = this;
    }

    return API.instance;
  }

  create() {
    this.api = apisauce.create({
      // base URL is read from the 'constructor'
      baseURL: this.baseURL,
      // here are some default headers
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken: new CancelToken((cancel) => {
        this.source = cancel;
      }),
      // 60 second timeout...
      timeout: 60000,
    });

    this.api.addRequestTransform(request => {
      if(['post', 'put', 'patch'].includes(request.method) && request.headers?.['Content-Type'] !== 'multipart/form-data' && request.data){
        request.data = encryptedData(request.data)
      }
    })
  }

  cancelAllRequest() {
    API.instance.source();
  }

  createInterceptor() {
    this.interceptors = this.api.axiosInstance.interceptors;
  }
}
